var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 57,
    viewBox: "0 0 238 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 55.027H1V2L1.5 2.48649L33.5 34.1081L33 2H43V55.027L10 23.4054V55.027Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55H56V2H79.5C90.5 5.5 92 12 92 21C92 28.2 85.6667 32.6667 82.5 34L83 34.5L94 55H93H83L69.5 27.5H70H78L79.5 26.5C80.6667 25.3333 83 21.9 83 17.5C83 13.1 78.6667 11 76.5 10.5H65V55Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 55H105H104V2H114V46.5H136L135.5 47.5L131.5 55Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 2H126L144.5 33L149 24.5L135.5 2Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 2.5L157 10H180L153.5 55H192V46.5H168.5L194.5 2.5H161.5Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 54.5V2H237V10.5H214V23.5H235V24.5V32.5H214V46.5H237.5V54.5H204.5Z",
    fill: "#0B3F51",
    stroke: "#0B3F51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLogo);
export default __webpack_public_path__ + "static/media/TextLogo.74aa4cc87f569645e146a90a8a2741e6.svg";
export { ForwardRef as ReactComponent };